import script from "./PPCManagementMixin.vue?vue&type=script&lang=js"
export * from "./PPCManagementMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__